<template>
  <div class="notree-boxbgcolor">
    <!-- <div class="content-left">
			<AreaTree ref='areaTree' :moduleName='moduleName' v-on:handleTreeClick="handleTreeClick"></AreaTree>
    </div>-->
    <!-- <div class="right content-right">   -->
    <div class="searchbox">
      <form action="#" method="get" class="form-inline form-float">
        <div class="form-group">
          <label for="a_name">名称</label>
          <input
            v-model.trim="search.name"
            class="form-control"
            type="text"
            placeholder
            size="12"
            v-noBlankSpace
          />
        </div>
        <div class="form-group others">
          <span class="search_btn">
            <el-button size='small' @click="searchList" type="primary" :loading="loading">查询</el-button>
          </span>
          <!--<button @click="clearSearch" type="button" class="btn btn-default">清空</button>-->
          <span class="add_btn">
            <button type="button" class="btn btn-default" id="add" @click="addOrEdit()">添加</button>
          </span>
          <!-- <span class="download_btn"><ExportExcel v-bind:tableListData="this.tableListData" v-bind:tableListDataAll="this.tableListDataAll" v-bind:downloadFileds="this.downloadFileds"></ExportExcel></span> -->
          <!-- <span class='refresh_btn'><Refresh @tableList="this.tableList"></Refresh></span> -->
        </div>
      </form>
    </div>
    <div class="list-right">
      <el-table
        ref="table"
        border
        :data="tableListData"
        height="100%"
        :header-cell-style="tableHeaderStyle"
        :cell-style="styleObj"
        v-loading="loading"
      >
        <el-table-column show-overflow-tooltip label="名称" prop="name"></el-table-column>
        <el-table-column show-overflow-tooltip label="联系人" prop="contact"></el-table-column>
        <el-table-column show-overflow-tooltip label="联系电话" prop="mobile"></el-table-column>
        <el-table-column show-overflow-tooltip label="地址" prop="address"></el-table-column>
        <el-table-column show-overflow-tooltip label="创建人" prop="crtUserName"></el-table-column>
        <!-- <el-table-column  show-overflow-tooltip
						label="创建人"
						prop="attr5"
					>
					</el-table-column>
					<el-table-column  show-overflow-tooltip
						label="状态"
						prop="attr6"
					>
        </el-table-column>-->
        <el-table-column show-overflow-tooltip label="操作">
          <template slot-scope="scope">
            <button class="edit operate-button" type="button" @click="addOrEdit(scope.row.id)">修改</button>
            <button class="delete operate-button" type="button" @click="del(scope.row.id)">删除</button>
            <button class="operate-button" type="button" @click="configure(scope.row.id)">配置</button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- </div> -->

    <!-- <Page :pageSize="search.pageSize"></Page> -->
    <Page v-on:pagination="receivePaginationData" v-bind:pageObj="pageObj"></Page>

    <!-- 添加/修改 -->
    <el-dialog
      :lock-scroll="false"
      :close-on-click-modal="false"
      title="添加/修改"
      :visible.sync="dialogFormVisible"
      width="500px"
      @close="closeFormDialog"
    >
      <div class="clearfix">
        <el-form
          @submit.prevent
          class="fl"
          style="width:100%;"
          ref="form"
          label-position="right"
          :model="form"
          :rules="rules"
          :label-width="formLabelWidth"
          id="form"
        >
          <el-form-item label="名称" prop="name">
            <el-col :span="18">
              <el-input v-model="form.name"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="联系人" prop="contact">
            <el-col :span="18">
              <el-input v-model="form.contact"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="电话" prop="mobile">
            <el-col :span="18">
              <el-input v-model="form.mobile"></el-input>
            </el-col>
          </el-form-item>
          <!-- <el-form-item label="联系人" prop='crtUserName'>
			    		<el-col :span="18">
			      			<el-input v-model="form.crtUserName"></el-input>
			      		</el-col>
          </el-form-item>-->
          <el-form-item label="地址" prop="address">
            <el-col :span="18">
              <el-input v-model="form.address"></el-input>
            </el-col>
          </el-form-item>
        </el-form>

        <!-- <div class="fr" id="areaMap" style="width: 52%;height: 380px;">
					
        </div>-->
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addOrEditTrue">确 定</el-button>
        <el-button @click="dialogFormVisible = false">取 消</el-button>
      </div>
    </el-dialog>

    <!--配置 -->
    <el-dialog
      :lock-scroll="false"
      :close-on-click-modal="false"
      title="配置"
      :visible.sync="dialogConfigureVisible"
      width="500px"
      @close="closeConfigureDialog"
    >
      <ul>
        <li v-for="item in groupConfigureData" :key="item.id">
          <span class="configure-message">{{item.labelDefault}}(单选)：</span>
          <span class="configure-message" @click="clickAreaToUsers(item,'open')">
            启用
            <template>
              <img v-if="item.isOpen" width="10px" src="@/assets/images/click.png" />
              <img v-else width="10px" src="@/assets/images/unclick.png" />
            </template>
          </span>
          <span class="configure-message" @click="clickAreaToUsers(item,'close')">
            关闭
            <template>
              <img v-if="item.isClose" width="10px" src="@/assets/images/click.png" />
              <img v-else width="10px" src="@/assets/images/unclick.png" />
            </template>
          </span>
        </li>
      </ul>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="configureOneGroupConfigure">确 定</el-button>
        <el-button @click="dialogConfigureVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapState, mapMutations, mapGetters } from "vuex";
import {
  deleteOneGroup,
  groupList,
  oneGroup,
  updateOneGroup,
  removeStation,
  requestGroupBaseConfig,
  getOneGroupConfigure,
  requestConfigureOneGroupConfigure,
} from "@/api/url";

import Page from "../../commons/page.vue";

import ExportExcel from "../../commons/exportExcel.vue";

import Refresh from "../../commons/refresh.vue";

import AreaTree from "../../commons/areaTree.vue";

export default {
  name:'group',
  data() {
    return {
      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },
      treeData: {
        parentId: "bf514be4c8f34514a71326c9c2dd7e87",
      },
      type: "group",
      moduleName: "group",
      form: {
        id: "",
        name: "",
        contact: "",
        mobile: "",
        address: "",
        crtUserName: "",
      },
      configureForm: {
        groupId: "",
        code: [],
      },
      search: {
        pageNumber: 1,
        pageSize: 10,
        name: "",
      },
      tableListData: [],
      tableListDataTitle: [],
      groupBaseConfigureData: [],
      groupConfigureData: [], //用户配置数据
      tableListDataExcel: {},
      formLabelWidth: "100px",
      dialogFormVisible: false,
      dialogFormHeartTimeVisible: false,
      dialogConfigureVisible: false, //配置

      isOpen: false, //配置
      isClose: false, //配置
      rules: {
        name: [{ required: true, message: "请填写名称", trigger: "blur" }],
        contact: [{ required: true, message: "请填写联系人", trigger: "blur" }],
        mobile: [{ required: true, message: "请填写电话", trigger: "blur" }],
        address: [{ required: true, message: "请填写地址", trigger: "blur" }],
      },
      pageObj:{},
      loading: false,
    };
  },
  activated(){
   
  },
  methods: {
    ...mapMutations(["getPage", "storageScenId"]),
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;
      this.tableList(this.search.pageNumber);
    },
    handleTreeClick(node, data) {
      this.treeData.parentId = node.id;
      // this.search.pageNumber=1;
      // this.tableList(this.search.pageNumber)
    },
    tableList:function (curPage) {
      var _this = this;
      this.loading = true;
      return this.$get(groupList(), {
        limit: this.search.pageSize,
        page: curPage,
        type: this.type,
        name: this.search.name,
      }).then((data) => {
        if (data.status != 200) return _this.$layer.msg(data.message);
        //翻页
        var pageObj = {
          curIndex: data.data.offset,
          rowsCount: data.data.total
        };
        _this.pageObj={...pageObj};
        // _this.getPage(pageObj);
        _this.tableListData = data.data.rows;
        _this.$nextTick(() => {
          _this.$refs.table.doLayout();
        });
      }).finally(() => {
        this.loading = false;
      });
    },
    openDialog: function () {},
    closeFormDialog: function () {
      this.$refs["form"].resetFields();
    },
    searchList:  function () {
      // if(!this.treeData.parentId){
      // 		this.$message({
      // 			type:"warning",
      // 			message:'请选择总账号'
      // 		})
      // 		return;
      // 	}
      
      this.search.pageNumber = 1;
       this.tableList(this.search.pageNumber);
      

    },
    clearSearch: function () {},
    addOrEdit: function (id) {
      this.dialogFormVisible = true;
      this.form.id = id;
      if (Boolean(id)) {
        this.$postRequest(oneGroup(), {
          id: id,
        }).then((data) => {
          if (data.status != 200) return _this.$layer.msg(data.message);
          this.form.name = data.data.name;
          this.form.mobile = data.data.mobile;
          this.form.address = data.data.address;
          this.form.contact = data.data.contact;
          // this.form.crtUserName=data.data.crtUserName;
        });
      } else {
        // if(!this.treeData.parentId){
        // 	this.$message({
        // 		type:'warning',
        // 		message:'请选择总账号'
        // 	})
        // 	this.dialogFormVisible=false;
        // 	return;
        // }

        this.form.name = "";
        this.form.mobile = "";
        this.form.address = "";
        this.form.contact = "";
        // this.form.crtUserName='';
      }
    },
    addOrEditTrue: function () {
      var _this = this;
      this.$refs["form"].validate(function (valid, noStri) {
        if (valid) {
          _this.dialogFormVisible = false;
          if (!Boolean(_this.form.id)) {
            _this
              .$postRequest(updateOneGroup(), {
                name: _this.form.name,
                mobile: _this.form.mobile,
                type: _this.type,
                address: _this.form.address,
                contact: _this.form.contact,
                // crtUserName:_this.form.crtUserName,
                parentId: _this.treeData.parentId,
              })
              .then((data) => {
                if (data.status != 200) return _this.$layer.msg(data.message);
                _this.$notify({
                  type: "success",
                  message: "添加成功",
                  title: "成功",
                });
                _this.search.pageNumber = 1;
                _this.tableList(_this.search.pageNumber);
              });
          } else {
            _this
              .$putRequest(updateOneGroup() + "/" + _this.form.id, {
                id: _this.form.id,
                type: _this.type,
                name: _this.form.name,
                mobile: _this.form.mobile,
                address: _this.form.address,
                contact: _this.form.contact,
                // crtUserName:_this.form.crtUserName,
                parentId: _this.treeData.parentId,
              })
              .then((data) => {
                if (data.status != 200) return _this.$layer.msg(data.message);
                _this.$notify({
                  type: "success",
                  message: "修改成功",
                  title: "成功",
                });
                _this.tableList(_this.pageObj.curIndex);
              });
          }
        }
      });
    },
    del: function (id) {
    
      var _this = this;
      var index = _this.$layer.confirm(
        "确定删除？",
        {
          btn: ["确定", "取消"],
          shade: false,
          type: 0,
        },
        function () {
          _this.$layer.close(index);
          _this.$deleteRequest(deleteOneGroup() + "/" + id, {}).then((data) => {
            if (data.status == 200) {
              _this.$notify({
                type: "success",
                message: "删除成功",
                title: "成功",
              });
              _this.search.pageNumber = 1;
              _this.tableList(_this.pageObj.curIndex);
            } else {
              data.status == -234;
              _this.$notify.error({
                message: "该集团下有物业，请先删除物业！",
                title: "失败",
              });
            }
          });
        }
      );
    },
    getGroupBaseConfigure() {
      this.$get(requestGroupBaseConfig()).then((data) => {
        if (data.status != 200) return;
        this.groupBaseConfigureData = data.data.rows;
      });
    },
    closeConfigureDialog() {
      this.configureForm.groupId = "";
      this.configureForm.code = [];
    },
    configure(id) {
      this.configureForm.groupId = id;
      this.oneGroupConfigure(id);
      this.dialogConfigureVisible = true;
    },
    clickAreaToUsers(item, dd) {
      let data = [];
      if (dd == "open") {
        data = this.groupConfigureData.map(function (val, index, array) {
          if (item.value == val.value) {
            val.isOpen = true;
            val.isClose = false;
          }
          return val;
        });
        this.configureForm.code.push(item.value);
      }
      if (dd == "close") {
        data = this.groupConfigureData.map(function (val, index, array) {
          if (item.value == val.value) {
            val.isOpen = false;
            val.isClose = true;
          }
          return val;
        });
      }
      this.groupConfigureData = data;
    },
    oneGroupConfigure(id) {
      var _this = this;
      this.$get(getOneGroupConfigure(), {
        groupId: id,
      }).then((data) => {
        if (data.status != 200) return;
        let dd = data.data;
        let dds = this.groupBaseConfigureData;
        if (dd.length > 0) {
          this.groupConfigureData = dds.map(function (val, index, array) {
            let itemFind = dd.find((item) => val.value === item.configCode);
            if (itemFind) {
              val.isOpen = true;
              val.isClose = false;
            } else {
              val.isOpen = false;
              val.isClose = true;
            }
            return val;
          });
        } else {
          this.groupConfigureData = dds.map(function (val, index, array) {
            val.isOpen = false;
            val.isClose = true;
            return val;
          });
        }
      });
    },
    configureOneGroupConfigure() {
      this.dialogConfigureVisible = false;
      let codes = [];
      for (let item of this.groupConfigureData) {
        if (item.isOpen) {
          codes.push(item.value);
        }
      }
      this.$postRequest(requestConfigureOneGroupConfigure(), {
        groupId: this.configureForm.groupId,
        codes: codes,
      }).then((data) => {
        if (data.status != 200) {
          this.$notify.error({
            type: "success",
            message: data.message,
            title: "失败",
          });
          return;
        }
        this.$notify({
          type: "success",
          message: "配置成功！",
          title: "成功",
        });
      });
    },
  },
  computed: {
    ...mapState({
      curIndex: (state) => state.page.curIndex,
      rowsCount: (state) => state.page.rowsCount,
    }),
    ...mapGetters(["elements"]),
    permiss() {
      // this.stationManger_btn_add = this.elements['stationManger:btn_add'];
      // this.stationManger_btn_remove = this.elements['stationManger:btn_remove'];
      // this.stationManger_btn_edit = this.elements['stationManger:btn_edit'];
      // this.stationManger_btn_heart = this.elements['stationManger:btn_heart'];
    },
  },
  components: {
    Page,
    ExportExcel,
    Refresh,
    AreaTree,
  },
  created: function () {
    this.permiss;
  },
  mounted: function () {
    this.search.pageNumber = 1;
    this.tableList(this.search.pageNumber);
    this.getGroupBaseConfigure();
    // this.tableListAll();
  },
  destroyed: function () {},
  watch: {
    elements: {
      handler: function (val, oldVal) {
        this.permiss;
      },
      deep: true, //深度
    },
  },
};
</script>

<style scoped>
.table-rule {
  color: #222;
  border-spacing: 0;
  border-collapse: collapse;
}
.table-rule tr td {
  padding: 10px 10px;
  text-align: center;
  border: 1px solid #ccc;
  font-size: 14px;
}

.table-rule .money-input,
.table-rule .time-input {
  width: 40px;
  height: 26px;
  border: 1px solid #ccc;
  /* border: 1px solid #02c1af; */
  border-radius: 2px;
  text-align: center;
  color: #222;
  color: #02c1af;
}

.searchbox {
  background: #f9f9fb;

  border-bottom: 10px solid #eff2f7;
}
.table thead {
  background: #f9f9fb;
}
.list {
  width: 100% !important;
  position: relative;
}
.pagbox {
  position: absolute;
  bottom: 5px;
  right: 5px;
}
/* .edit,
.delete,
.chargingRules {
  display: inline-block;
  width: 40px;
  height: 20px;
  background: #278cd8;
  color: white;
  margin-right: 4px;
  font-size: 12px;
  line-height: 20px;
  border-radius: 4px;
} */
.chargingRules {
  width: 60px;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.fail,
.success,
.someSuccess {
  display: inline-block;
  border-radius: 4px;
  width: 12px;
  height: 12px;
}
.fail {
  background: red;
  color: red;
}
.success {
  background: green;
  color: green;
}
.someSuccess {
  background: #ff6100;
  width: 65px;
  height: 20px;
  line-height: 20px;
  color: white;
  font-size: 12px;
}
.lowerEquip {
  width: 60px;
  font-size: 12px;
  background: #409eff;
  color: white;
  height: 20px;
  line-height: 20px;
}
.refresh {
  display: inline-block !important;
}
.pow {
  text-align: left !important;
  padding-left: 1% !important;
}
.show_pow {
  border: 1px solid #696969;
  border-radius: 2px;
}
.pow_head {
  margin-left: -5%;
  border-radius: 1px;
}
.configure-message {
  margin-right: 20px;
}
.configure-message img {
  align: absmiddle;
}
</style>